import { Component } from '@angular/core';

@Component({
  selector: 'app-root-auth',
  templateUrl: './auth.component.html'
})
export class AuthComponent {
  title = 'sl-video-web';
}
